import React from 'react';

function HowItWorksAttorneyClient() {
  const howItworksObj = [{
    "title": "Step 1A",
    "description":"Potential client creates an account and creates a case by clicking on the 'Create Case' button.",
    "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItworksAttAndClient/1A.png", 
      
    ]
  },

  {
    "title": "Step 1B",
    "description": "Potential client agrees to contact all attorneys on the platform.",
    "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItworksAttAndClient/1B.png",
      "https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItworksAttAndClient/1b1.png"

    ]
  },
  {
    "title": "Step 1C",
    "description" : " Upon creating the case, Potential client is presented with one or more attorneys, whose expertise and location matches information associated with the case. Potential client pre-approves one or more attorneys, if desired.",
    "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItworksAttAndClient/1C.png"],
  },
  {
    "title": "Step 1D",
    "description" : " Potential client is presented with a case tracker for tracking status of the case.",
    "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItworksAttAndClient/1D.png",
    ]
  },
  {
    "title": "Step 2A",
    "description":" Attorney logs into their account and accesses the “Cases just posted” tab under the 'Available Cases' section. Cases or case information in purple is available only to premium member attorneys.",
    "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItworksAttAndClient/2A.png",
    ]
  },
  {
    "title": "Step 2B",
    "description":" Attorney requests to view more information about the case, thereby moving the case to the 'Requested cases' tab",
    "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItworksAttAndClient/2B.png",
    ]
  },
  {
    "title": "Step 3A",
    "description":"Potential client receives notification of Attorney’s request.",
    "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItworksAttAndClient/3A.png",
    ]
  },
  {
    "title": "Step 3B",
    "description":"Potential client’s case tracker is updated.",
    "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItworksAttAndClient/3B.png",
    ]
  },
  { 
    "title": "Step 3C",
    "description":"3C: Potential client is presented with option to view details of Attorney. Potential client approves Attorney to view case information.",
    "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItworksAttAndClient/3C.png",
    ]
  },
  {
    "title": "Step 4A",
    "description":"Attorney is notified of Potential client’s approval of Attorney’s request.",
    "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItworksAttAndClient/4A.png",
    ]
  },
  {
    "title": "Step 4B",
    "description":"Case is moved to Attorney’s “Approved Cases” tab under the “Active Cases” section.",
    "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItworksAttAndClient/4B.png",
    ]
  },
  {
    "title": "Step 4C",
    "description":"When Attorney selects “Check for Conflict,” Attorney is presented with the name of the Potential client (if provided) and the name of the adverse party. Attorney is instructed to conduct a conflicts check to proceed to next steps",
    "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItworksAttAndClient/4C.png"],
    
  },
  {
    "title": "Step 4D",
    "description":"Attorney is presented with a confirmation box after selecting the “No Conflict” option.",
    "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItworksAttAndClient/4D.png",
    ]
  },
  {
    "title": "Step 5",
    "description":"Potential client is notified that no conflicts are present and that Attorney is reviewing all provided case details. Potential client’s case tracker is also updated (not shown here).",
    "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItworksAttAndClient/5.png",
    ]
  },
  {
    "title": "Step 6A",
    "description":"Once Attorney confirms that they would have no conflicts in potentially representing Potential client in a case against the adverse party, the case is moved to the “My cases” tab of Attorney’s account.",
    "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItworksAttAndClient/6.png",
    ]
  },
  {
    "title": "Step 6C",
    "description":"Attorney can scroll down to view all case details. Attorney has the option to report the case as spam,among other options. Alternatively, Attorney has the option to “Request to close case.",
    "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItworksAttAndClient/6C.png",
    ]
  },
  {
    "title": "Step 6D",
    "description":"When Attorney selects “Request to close case,” a popup window is provided confirming whether a client representation agreement has been signed with Potential client.",
    "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItworksAttAndClient/6D.png",
    ]
  },
  {
    "title" : "Step 6E",
    "description":"Case is now moved to the “Pending Closing” tab under the “Closed Cases” section of Attorney’s account",
    "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItworksAttAndClient/6E.png",
    ]
  },
  {
    "title": "Step 7A",
    "description":"Client (formerly Potential client) is notified that Attorney has requested to close the case.",
    "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItworksAttAndClient/7A.png",
    ]
  },
  {
      "title": "Step 7B",
      "description":"Client’s case tracker is updated to the “Request to close” status.",
      "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItworksAttAndClient/7B.png",
      ]
  },
  {
    "title": "Step 7C",
    "description":"When Client selects “Close case,” Client’s case tracker is updated to the “Closed” status.",
    "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItworksAttAndClient/7C.png",
    ]
  },
  {
    "title": "Step 8A",
    "description":"Case is moved to “Closed cases” tab in “Closed cases” section of Attorney’s account.",
    "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItworksAttAndClient/8A.png",
    ]
  },
  {
    "title": "Step 8B",
    "description":"Attorney is notified that the case will be deleted from the platform within 7 days.",
    "img":["https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/howItworksAttAndClient/8B.png",
    ]
  },
]
    return (
        <div className='lg:p-10 px-2 lg:px-20 bg-gray-100'>
          <div className='font-bold text-sm lg:text-3xl text-gray-700 text-center mb-14 mt-10'>
          A Quick Guide for Attorneys and Clients to understand how our website works (2-Minute Read)
          </div> 

          <div className='text-gray-900 text-left mb-4 mt-10'>
            <div>
                {howItworksObj.map((item, index) => {
                    return (
                        <div key={index} className='flex flex-col mb-4 text-sky-900 mt-2'>
                            <div className='lg:text-xl font-bold flex item-end mb-3 w-full mt-10'>{item.title} : {item.description}</div>
                            
                            {item?.img?.map((img, index) => {
                                return (
                                    <div key={index} className='flex border-sky-800  justify-center lg:p-20 border rounded shadow-lg mt-10'>
                                        <img src={img} alt={item.title} className='rounded border ' />
                                    </div>
                                )
                            })}
                        </div>
                    )
                })}
            </div>
          </div>
        </div>
    );
}

export default HowItWorksAttorneyClient;